import script from "./msgNotice.vue?vue&type=script&setup=true&lang=js"
export * from "./msgNotice.vue?vue&type=script&setup=true&lang=js"

import "./msgNotice.vue?vue&type=style&index=0&id=33a29f56&lang=scss&scoped=true"

import exportComponent from "/Users/ioblabs/work/weina/production/weina_oms_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-33a29f56"]])

export default __exports__